import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from '@phosphor-icons/react'

const Navbar = ({ onBack = () => {}, templateButton, inspectionButton, isEdit }) => {
  const { t } = useTranslation(['internal-inspections', 'common'])

  return (
    <div className="inspections-top-navbar">
      <div className="header-buttons">
        <button onClick={onBack} className="button button-lightgray" type="button">
          <ArrowLeft />
          {t('common:actions.back')}
        </button>
        <div className="header">
          {isEdit
            ? t('internal-inspections:scheduleInspectionViewNavbar.editInspection')
            : t('internal-inspections:scheduleInspectionViewNavbar.createInspection')}
        </div>
      </div>
      <div className="header-buttons">
        {templateButton}
        {inspectionButton}
      </div>
    </div>
  )
}

Navbar.propTypes = {
  onBack: PropTypes.func,
  templateButton: PropTypes.node,
  inspectionButton: PropTypes.node,
  isEdit: PropTypes.bool,
}

export default Navbar
